import React from 'react';
import { TableCell, TableRow } from '../ui/table.tsx';
import { Avatar, AvatarImage } from '../ui/avatar.tsx';
import { AvatarFallback } from '@radix-ui/react-avatar';
import { Checkbox } from '../ui/checkbox.tsx';
import { Textarea } from '../ui/textarea.tsx';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown.tsx';
import { Button } from '../ui/button.tsx';
import { MoreHorizontal } from 'lucide-react';

const AttendanceRowData = ({
  student,
  handleAttendanceChange,
  handleCommentChange,
}) => {
  return (
    <TableRow
      key={student.childId}
      className="hover:bg-gray-50 divide-x divide-gray-200"
    >
      <TableCell>
        <div className="flex items-center">
          <Avatar className="mr-2">
            <AvatarImage
              src={student.photoUrl || '/placeholder.svg'}
              alt={student.firstname}
            />
            <AvatarFallback>
              {`${student.firstName} ${student.lastName}`.substring(0, 2)}
            </AvatarFallback>
          </Avatar>
          <span>
            {student.firstName} {student.lastName}
          </span>
        </div>
      </TableCell>
      <TableCell className="text-center">
        <div className="flex justify-center items-center">
          <Checkbox
            id={`attendance-${student.childId}`}
            checked={student.present}
            onCheckedChange={(checked) =>
              handleAttendanceChange(student.childId, checked)
            }
            className="data-[state=checked]:bg-purple-500 data-[state=checked]:border-purple-500"
          />
          <label
            htmlFor={`attendance-${student.childId}`}
            className="ml-2 text-sm font-medium text-gray-500"
          >
            Present
          </label>
        </div>
      </TableCell>
      <TableCell className="w-1/3">
        <Textarea
          placeholder="Enter a Comment..."
          className="min-h-[80px] resize-none"
          value={student.comment}
          onChange={(e) => handleCommentChange(student.childId, e.target.value)}
        />
      </TableCell>
      <TableCell>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon" className="h-8 w-8">
              <MoreHorizontal className="h-4 w-4" />
              <span className="sr-only">Open menu</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem>View Profile</DropdownMenuItem>
            <DropdownMenuItem>Mark as Late</DropdownMenuItem>
            <DropdownMenuItem>Excused Absence</DropdownMenuItem>
            <DropdownMenuItem>Contact Parent</DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </TableCell>
    </TableRow>
  );
};

export default AttendanceRowData;
